import BaseDocumentHead, { IDocumentHead } from 'components/DocumentHead'
import TrackContentPageView from 'helpers/tracking/trackerComponents/TrackContentPageView'
import React, { FC } from 'react'

const DocumentHead: FC<Partial<IDocumentHead>> = props => {
  return (
    <>
      <TrackContentPageView pageTitle={props.title || ''} />
      <BaseDocumentHead {...props} />
    </>
  )
}

export default DocumentHead
